import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ element, roles = [] }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress sx={{ color: "#002943" }} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/equipe-acsp2026" />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    return location.pathname !== "/convidados" ? <Navigate to="/convidados" /> : null;
  }

  return element;
};

export default PrivateRoute;
